// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__0Srvo","right":"styles_right__GI9s-","left":"styles_left__od5x-"};